const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://127.0.0.1:8787';

export type RoleMasterItem = {
  id: number;
  name: string;
};

export type PositionMasterItem = {
  id: number;
  positionName: string;
};

export type AccountItem = {
  id: string;
  email: string;
  name: string;
  department: string | null;
  roleId: number;
  roleName: string;
  positionId: number | null;
  positionName: string | null;
  lastLoginAt: string | null;
  createdAt: string;
};

async function throwIfNotOk(response: Response) {
  if (response.ok) return;
  const payload = await response.json().catch(() => ({}));
  const message =
    typeof payload.message === 'string' ? payload.message : 'API request failed';
  throw new Error(message);
}

export async function fetchAccountMasters() {
  const response = await fetch(`${apiBaseUrl}/api/admin/account-masters`);
  await throwIfNotOk(response);
  return (await response.json()) as {
    roles: RoleMasterItem[];
    positions: PositionMasterItem[];
  };
}

export async function fetchAccountList() {
  const response = await fetch(`${apiBaseUrl}/api/admin/accounts`);
  await throwIfNotOk(response);
  const payload = (await response.json()) as { users: AccountItem[] };
  return payload.users;
}

export async function createAccount(input: {
  email: string;
  name: string;
  roleId: number;
  positionId: number | null;
  department: string | null;
}) {
  const response = await fetch(`${apiBaseUrl}/api/admin/accounts`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
}

export async function deleteAccount(userId: string) {
  const response = await fetch(`${apiBaseUrl}/api/admin/accounts/${userId}`, {
    method: 'DELETE',
  });
  await throwIfNotOk(response);
}

export async function updateAccount(
  userId: string,
  input: {
    email: string;
    name: string;
    roleId: number;
    positionId: number | null;
    department: string | null;
  },
) {
  const response = await fetch(`${apiBaseUrl}/api/admin/accounts/${userId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
}

export async function replacePositionMasterList(input: {
  positions: {
    id: number;
    positionName: string;
  }[];
}) {
  const response = await fetch(`${apiBaseUrl}/api/admin/position-masters`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
  const payload = (await response.json()) as { positions: PositionMasterItem[] };
  return payload.positions;
}

export async function createPositionMaster(input: {
  positionName: string;
}) {
  const response = await fetch(`${apiBaseUrl}/api/admin/position-masters`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
  const payload = (await response.json()) as { position: PositionMasterItem };
  return payload.position;
}

export async function updatePositionMaster(
  id: number,
  input: {
    positionName: string;
  },
) {
  const response = await fetch(`${apiBaseUrl}/api/admin/position-masters/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  await throwIfNotOk(response);
}

export async function deletePositionMaster(id: number) {
  const response = await fetch(`${apiBaseUrl}/api/admin/position-masters/${id}`, {
    method: 'DELETE',
  });
  await throwIfNotOk(response);
}
